<template>
  <CRow>
    <CCol md="12" style="font-size: 14px; margin-bottom: 80px;">

      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 30 : 50"
        :dark="dark"
        pagination
        :table-filter="{ label: 'Buscar: ', placeholder: '...' }"
        :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin Invitados' }"
      >
        <template #position="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.position }}</td>
        </template>

        <template #name="{ item }">
          <td class="text-left w150" style="font-size: 12px;">
            <b style="font-size: 12px;">{{ item.name }}</b>
          </td>
        </template>

        <template #last_name="{ item }">
          <td class="text-left w150" style="font-size: 12px;">
            <b style="font-size: 12px;">{{ item.last_name }}</b>
          </td>
        </template>

        <template #nickname="{ item }">
          <td class="text-left w150" style="font-size: 12px;">{{ item.nickname }}</td>
        </template>

        <template #phone="{ item }">
          <td class="text-center w100" style="font-size: 12px;">
            {{ item.phone }}
            <template v-if="item.email != ''">
              <div style="font-size: 11px;">{{ item.email }}</div>
            </template>
          </td>
        </template>

        <template #tickets="{ item }">
          <td class="text-center" style="font-size: 12px;">
            <template v-if="event.external_registration_enabled">
              {{ item.tickets }} / {{ item.attendance }}
            </template>
            <template v-else>
              {{ item.tickets }}
            </template>
          </td>
        </template>

        <template #table="{ item }">
          <td class="text-center" style="font-size: 12px;">
            <template v-if="item.table != ''">
              {{ item.table }}
            </template>
            <template v-else>
              -
            </template>
          </td>
        </template>

        <template #has_restriction="{ item }">
          <td class="text-center" style="font-size: 12px;">
            {{ (item.has_restriction) ? "Si" : "No" }}
          </td>
        </template>

        <template #comments="{ item }">
          <td class="text-left" style="font-size: 12px;">{{ item.comments }}</td>
        </template>

        <template #is_confirm="{ item }">
          <td class="text-center w100" style="font-size: 16px;">
            <template v-if="item.is_confirm == 0">
              <CBadge v-if="Number(item.is_attended) === 1" color="info">Atendió</CBadge>
              <CBadge v-else color="warning">Pendiente</CBadge>
            </template>
            <template v-else-if="item.is_confirm == 3">
              <CBadge color="warning">Incompleta</CBadge>
            </template>
            <template v-else-if="item.is_confirm == 2">
              <CBadge color="danger">No</CBadge>
            </template>
            <template v-else>
              <CBadge color="success">Si</CBadge>
            </template>

            <template v-if="item.is_confirm != ''">
              <div style="font-size:11px;">{{ item.confirm_date | date }}</div>
            </template>

            <template v-if="item.confirm_method == 'admin'">
              <div style="font-size:11px;">Administrador</div>
            </template>
            <template v-else-if="item.confirm_method == 'whats'">
              <div style="font-size:11px;">Whatsapp</div>
            </template>
            <template v-else-if="item.confirm_method == 'email'">
              <div style="font-size:11px;">Correo Electronico</div>
            </template>

            <template v-if="item.confirm_folio != ''">
              <div style="font-size:10px;">{{ item.confirm_folio }}</div>
            </template>
          </td>
        </template>

        <template #history="{ item }">
          <td class="text-center" style="font-size: 12px;">
            <template v-if="isInCooldown(item)">
              <div><CBadge color="warning">En cooldown</CBadge></div>
              <div style="font-size: 11px;">Cooldown hasta: {{ item.whatsapp_cooldown_until | datetime }}</div>
            </template>
            <template v-if="item.last_whatsapp_date">
              <div style="font-size: 11px;">Enviado: {{ item.last_whatsapp_date | datetime }}</div>
              <div style="font-size: 11px;">{{ getTypeLabel(item.last_whatsapp_type) }}</div>
              <div style="font-size: 11px;">{{ getWhatsappStatusLabel(item.last_whatsapp_status) }}</div>
            </template>
            <template v-else-if="!$isNullorUndefined(item.last_history)">
              Enviado: {{ item.last_history.date | datetime }}
            </template>
            <template v-else>
              -
            </template>
          </td>
        </template>

        <template #actions="{ item }">
          <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">

            <CButton
              v-if="showButton('edit-guest')"
              color="warning"
              style="color: #fff"
              size="sm"
              @click="$emit('edit-guest', item)"
            >
              <CIcon name="cil-pencil" />
            </CButton>

            <CButton
              v-if="showButton('delete-guest')"
              color="dark"
              size="sm"
              @click="$emit('delete-guest', item)"
            >
              <CIcon name="cil-trash" />
            </CButton>

            <CButton
              v-if="showButton('confirm-guest')"
              color="success"
              style="color: #fff"
              size="sm"
              @click="$emit('confirm-guest', item)"
            >
              <CIcon name="cil-check-circle" />
            </CButton>

            <CButton
              v-if="showButton('view-conversation', item)"
              color="primary"
              size="sm"
              @click="$emit('open-conversation', item)"
              title="Ver conversación"
            >
              <CIcon name="cil-speech" />
            </CButton>

            <table style="padding: 0px; margin: auto;">
              <tr>
                <td style="padding: 0px; border: 0px !important;">
                  <CButton
                    v-if="getAllActions(item).length > 0"
                    color="info"
                    size="sm"
                    @click="getAllActions(item)[0].action()"
                  >
                    {{ getAllActions(item)[0].label }}
                  </CButton>
                </td>

                <td style="padding: 0px; border: 0px !important;">
                  <CDropdown
                    v-if="getAllActions(item).length > 1"
                    color="info"
                    togglerText=""
                    size="sm"
                  >
                    <CDropdownItem
                      v-for="(action, index) in getAllActions(item).slice(1)"
                      :key="index"
                      href="#"
                      @click="action.action()"
                    >
                      {{ action.label }}
                    </CDropdownItem>
                  </CDropdown>
                </td>
              </tr>
            </table>

          </td>
        </template>

      </CDataTable>

    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'GuestsTable',
  props: {
    items: { type: Array, required: true },
    event: { type: Object, required: true },

    // Mantener compatibilidad con tu uso original
    hover: { type: Boolean, default: true },
    striped: { type: Boolean, default: true },
    border: { type: Boolean, default: true },
    small: { type: Boolean, default: true },
    fixed: { type: Boolean, default: true },
    dark: { type: Boolean, default: false },

    // Si ya lo calculas en el padre, lo pasas y listo
    hasTables: { type: Number, default: 0 }, 
  },
  computed: {
    fields() {
      const base = [
        { key: 'position', label: 'N°', _style: 'width: 50px; font-size:12px;' },
        { key: 'name', label: 'Nombre', _style: 'font-size:12px;' },
        { key: 'last_name', label: 'Apellido', _style: 'font-size:12px;' },
        { key: 'nickname', label: 'Apodo', _style: 'font-size:12px;' },
        { key: 'phone', label: 'Whatsapp / Email', _style: 'width: 100px; font-size:12px;' },
        { key: 'tickets', label: this.event.external_registration_enabled ? 'Invitados/Asistencia' : 'Invitados', _style: 'width: 70px; font-size:12px;' },
        { key: 'table', label: 'Mesa', _style: 'width: 70px; font-size:12px;' },
        { key: 'has_restriction', label: 'Restricción Alimenticia', _style: 'width: 80px; font-size:12px;' },
        { key: 'comments', label: 'Comentario', _style: 'font-size:12px;' },
        { key: 'is_confirm', label: 'Confirmación', _style: 'font-size:12px;' },
        { key: 'history', label: 'Ultimo Mensaje', _style: 'width: 120px; font-size:12px;' },
        { key: 'actions', label: 'Acciones', class: 'actions', _style: 'font-size:12px;' },
      ]

      return base
    }
  },
  methods: {
    isInCooldown(item) {
      if (!item) return false
      return Number(item.is_in_cooldown) === 1 && !!item.whatsapp_cooldown_until
    },

    canSendReminder(item) {
      if (!item) return false

      const isIncomplete = Number(item.is_confirm) === 3
      const hasEvidence = Number(item.has_invitation_evidence) === 1
      return isIncomplete && hasEvidence && !this.isInCooldown(item)
    },

    canSendInvitation(item) {
      if (!item) return false

      const isCandidate = [0, 3].includes(Number(item.is_confirm))
      return isCandidate && !this.isInCooldown(item) && !this.isInvitationRestrictedByTickets(item)
    },

    isInvitationRestrictedByTickets(item) {
      if (!item) return false

      const tickets = Number(item.tickets)
      return !Number.isNaN(tickets) && tickets > 10
    },

    getTypeLabel(type) {
      switch (type) {
        case 'save_the_date': return 'Save The Date'
        case 'preinvitation': return 'Preinvitacion'
        case 'event_reminder': return 'Recordatorio de Evento'
        case 'reminder': return 'Recordatorio'
        case 'message': return 'Mensaje'
        case 'table': return 'Mesas'
        case 'tickets': return 'Tickets'
        case 'invitation': return 'Invitación'
        default: return type || '-'
      }
    },

    getWhatsappStatusLabel(status) {
      switch ((status || '').toLowerCase()) {
        case 'request': return 'No enviado'
        case 'send':
        case 'sent': return 'Enviado'
        case 'delivered': return 'Entregado'
        case 'read': return 'Leido'
        case 'failed': return 'Error'
        case 'pending': return 'Pendiente'
        default: return status || '-'
      }
    },

    showButton(type = "save", item = null) {
      if (!this.event || !this.event.status) return false

      switch (type) {
        case "edit-guest":
        case "delete-guest":
        case "confirm-guest":
          return this.event.status.code === "open"

        case "send-guest-reminder-phone":
          return this.event.status.code === "open" &&
                 this.event.contact_method != "email" &&
                 this.canSendReminder(item)

        case "send-guest-invitation-phone":
          return this.event.status.code === "open" &&
                 this.event.contact_method != "email" &&
                 this.canSendInvitation(item)

        case "send-guest-tickets-email":
          return this.event.status.code === "open" &&
                 this.event.contact_method == "email"

        case "download-tickets":
          return this.event.external_registration_enabled &&
                 item && item.is_confirm == 1

        case "view-conversation":
          return this.event.contact_method != "email" &&
                 item && !!item.phone

        case "external-download-tickets":
          return this.event.external_registration_enabled &&
                 item && item.is_confirm == 1

        default:
          return false
      }
    },

    getAllActions(item) {
      const actions = []

      if (this.showButton('send-guest-invitation-phone', item)) {
        actions.push({
          label: 'Invitación',
          action: () => this.$emit('send-guest-invitation', item)
        })
      }

      if (this.showButton('send-guest-reminder-phone', item)) {
        actions.push({
          label: 'Recordatorio',
          action: () => this.$emit('send-guest-reminder', item)
        })
      }

      if (this.showButton('send-guest-tickets-email', item)) {
        actions.push({
          label: 'Enviar tickets',
          action: () => this.$emit('send-guest-tickets', item)
        })
      }

      if (this.showButton('download-tickets', item)) {
        actions.push({
          label: 'Boletos',
          action: () => this.$emit('download-tickets', item)
        })
      }

      if (this.showButton('external-download-tickets', item)) {
        actions.push({
          label: 'Enlace de descarga',
          action: () => this.$emit('external-download-tickets', item)
        })
      }

      if (this.showButton('history-invitation', item)) {
        actions.push({
          label: 'Historial Invitaciones',
          action: () => this.$emit('history-invitation', item)
        })
      }

      return actions
    }
  }
}
</script>
